import { Component, ViewChild, ViewContainerRef, ComponentRef, Injector, OnDestroy, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { Modal } from '../../../core/services/modal';

@Component({
  selector: 'app-modal-container',
  templateUrl: './modal-container.html',
  styleUrls: ['./modal-container.css'],
  imports: [CommonModule]
})
export class ModalContainer implements AfterViewInit, OnDestroy {
  @ViewChild('modalHost', { read: ViewContainerRef })
  modalHost!: ViewContainerRef;

  modalRef!: ComponentRef<any>;
  subscription!: Subscription;

  isModalOpen = false;
  modalComponent: any = null;
  modalOptions: any = {};

  constructor(
    private modalService: Modal,
    private injector: Injector,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.subscription = this.modalService.modal$.subscribe(modalState => {
      this.isModalOpen = modalState.isVisible;
      this.modalComponent = modalState.component;
      this.modalOptions = modalState.options || {};

      if (this.isModalOpen) {
        this.openModal();
      } else {
        this.closeModal();
      }
    });
  }

  private openModal() {
    this.lockBodyScroll();

    // Ensure ng-template is rendered before accessing ViewContainerRef
    this.cdr.detectChanges();

    if (!this.modalHost || !this.modalComponent) return;

    this.modalHost.clear();

    this.modalRef = this.modalHost.createComponent(this.modalComponent, {
      injector: this.injector
    });

    if (this.modalRef.instance) {
      this.modalRef.instance.options = this.modalOptions;
    }
  }

  private closeModal() {
    this.unlockBodyScroll();
    this.modalHost?.clear();
  }

  onBackdropClick() {
    if (this.modalOptions?.backdropClosable ?? true) {
      this.modalService.close();
    }
  }

  private lockBodyScroll() {
    this.renderer.setStyle(document.body, 'overflow', 'hidden');
  }

  private unlockBodyScroll() {
    this.renderer.removeStyle(document.body, 'overflow');
  }

  ngOnDestroy() {
    this.unlockBodyScroll();
    this.modalHost?.clear();
    this.subscription.unsubscribe();
  }
}